import {CaptureConsole} from '@sentry/integrations';
import {init, configureScope, captureMessage, captureException, captureEvent, addBreadcrumb} from '@sentry/browser';

const Sentry = window.Sentry || {};

export const initSentry = () => {
    if (Sentry.initialized) {
        return;
    }

    if (Sentry.dsn) {
        init({
            ...window.Sentry,
            ...{
                integrations: [new CaptureConsole({
                    levels: ['error'],
                })],
            },
            // Leave it here, might be useful for debugging.
            // beforeBreadcrumb: function (breadcrumb, hint) {
            //     return breadcrumb;
            // },
        });
        Sentry.initialized = true;

        if (Sentry.user) {
            configureScope(scope => scope.setUser(Sentry.user));
        }

        Sentry.message = captureMessage;
        Sentry.exception = captureException;
        Sentry.event = captureEvent;

        Sentry.addBreadcrumbWarn = (category, message) => {
            addBreadcrumb(
                createBreadcrumb(
                category,
                message,
                "warning",
            ));
        };
        Sentry.addBreadcrumbInfo = (category, message) => {
            addBreadcrumb(
                createBreadcrumb(
                category,
                message,
                "info",
            ));
        };
        Sentry.addBreadcrumbFatal = (category, message) => {
            addBreadcrumb(
                createBreadcrumb(
                category,
                message,
                "fatal",
            ));
        };

        const key = "stashedBreadcrumb";
        Sentry.stashBreadcrumb = (category, message) => {
            if (!!sessionStorage) {
                sessionStorage.setItem(key, JSON.stringify({category, message, datetime: Date(), stashed: true}));
            }
        };

        Sentry.unstashBreadcrumb = () => {
            if (!!sessionStorage && sessionStorage.getItem(key) != null) {
                const val = sessionStorage.getItem(key);
                sessionStorage.removeItem(key);
                const {category, message, datetime, stashed} = JSON.parse(val);
                addBreadcrumb(
                    createBreadcrumb(
                        category,
                        JSON.stringify({message, datetime, stashed}),
                        "info",
                ));
            }
        };
    } else {
        Sentry.message = message => console.log("SENTRY NOT CONFIGURED", message);
        Sentry.exception = exception => console.error("SENTRY NOT CONFIGURED", exception);
        Sentry.event = event => console.error("SENTRY NOT CONFIGURED", event);

        Sentry.addBreadcrumbWarn = (category, message) => console.error("SENTRY NOT CONFIGURED", category, message);
        Sentry.addBreadcrumbInfo = (category, message) => console.error("SENTRY NOT CONFIGURED", category, message);
        Sentry.addBreadcrumbFatal = (category, message) => console.error("SENTRY NOT CONFIGURED", category, message);

        Sentry.stashBreadcrumb = (category, message) => console.error("SENTRY NOT CONFIGURED", category, message);
        Sentry.unstashBreadcrumb = () => console.error("SENTRY NOT CONFIGURED");
    }
};
initSentry();


const createBreadcrumb = (category, message, level) => {
    // Commented console.log out, only for local use
    // console.log('BREADCRUMB', category, level, message);
    return {
        level,
        category,
        message,
    };
};



// WEBPACK FOOTER //
// ./scripts/sentry.js